import StoreStateInterface from "./store-state-interface";

const storeState: StoreStateInterface = {
  brand: null,
  signboardContents:[],
  magazineContents: [],
};

export default storeState;
